import { createSelector } from 'reselect'
import isNewCustomerSelect from 'modules/customer/redux/selectors/is-new-customer'
import isDeliveryAvailableShippingSelect from 'modules/shipping/redux/selectors/is-delivery-available'
import isEligibleToTemporaryUnlockedSamplesSelectUtil from 'modules/temporary-unlocked-samples/redux/selectors/is-eligible-to-temporary-unlocked-samples/utils'
import getZipCodeShippingSelect from 'modules/shipping/redux/selectors/get-zip-code'

const isEligibleToTemporaryUnlockedSamplesSelect = createSelector(
  isNewCustomerSelect,
  isDeliveryAvailableShippingSelect,
  getZipCodeShippingSelect,
  (isNewCustomer, isDeliveryAvailable, zipCode) => {
    return isEligibleToTemporaryUnlockedSamplesSelectUtil({
      isNewCustomer,
      isDeliveryAvailable,
      zipCode
    })
  }
)

window.isEligibleToTemporaryUnlockedSamplesSelectReduxWrapper = () => {
  return isEligibleToTemporaryUnlockedSamplesSelect(window.store.getState())
}

export default isEligibleToTemporaryUnlockedSamplesSelect
